<template>
  <div class="ScenicAdminApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <div class="scenicList">
      <img class="fmt" :src="baseUrl+setDetail.img" />
      <div class="con">
        <h2>{{setDetail.title}}</h2>
        <p>营业时间：{{setDetail.business}}</p>
        <p>近期浏览：{{setDetail.read_num}}次</p>
      </div>
      <div class="level">景区等级：<font>{{setDetail.level}}</font>
        <span @click="toPush(setDetail.id,'role')">超级管理员<img src="~assets/images/icon5.png"></i></span>
      </div>
      <div class="level">景区门票管理</font>
        <span @click="toPush(setDetail.id,'ticketype')">查看<img src="~assets/images/icon5.png"></i></span>
      </div>
    </div>
    
    <div class="parkData">
      <h2>
        <div @click="toPush(setDetail.id,'entry')">入园数据分析图 <i>更多<img src="~assets/images/icon5.png"></i></div>
        <div class="amounts">
          <span>{{parkTotal}} <font>(近{{parkDay}}日新增)</font></span>
          <div class="tab">
            <a :class="parkDay == 7 ? 'curt' : ''" @click="parkClick(7)">7日</a>
            <a :class="parkDay == 30 ? 'curt' : ''" @click="parkClick(30)">30日</a>
          </div>
        </div>
      </h2>

      <div id="park" style="height:180px;margin-top:30px"></div>
    </div>

    <div class="parkData">
      <h2>
        <div @click="toPush(setDetail.id,'finance')">财务数据分析图 <i>更多<img src="~assets/images/icon5.png"></i></div>
        <div class="amounts">
          <span>{{moneyTotal}} <font>({{moneyMsg}}收入)</font></span>
          <div class="tab">
            <a :class="moneyMsg == '上月' ? 'curt' : ''" @click="moneyClick(2)">上月</a>
            <a :class="moneyMsg == '本月' ? 'curt' : ''" @click="moneyClick(1)">本月</a>
          </div>
        </div>
      </h2>
      <div id="money" style="height:180px;margin-top:30px"></div>
    </div>

    <div class="parkData">
      <h2>
        <div @click="toPush(setDetail.id,'morder')">订单分析图 <i>更多<img src="~assets/images/icon5.png"></i></div>
        <div class="amounts">
          <span>{{ticketTotal}} <font>(近{{ticketDay}}日成交数)</font></span>
          <div class="tab">
            <a :class="ticketDay == 7 ? 'curt' : ''" @click="ticketClick(7)">7日</a>
            <a :class="ticketDay == 30 ? 'curt' : ''" @click="ticketClick(30)">30日</a>
          </div>
        </div>
      </h2>
      <div id="payment" style="height:180px;margin-top:30px"></div>
    </div>
    <div style="height:15px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        setDetail:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setData:[],
        parkTotal:0,
        parkDay:7,
        ticketTotal:0,
        ticketDay:7,
        moneyTotal:0,
        moneyMsg:'本月',
        status:1
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getPark();
      this.getMoney();
      this.getTicket();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/spot',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      parkClick:function(d){
        this.parkDay = d;
        this.getPark();
      },
      getPark:function(e){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/parkTotal',
          params:{
            id:id,
            days:that.parkDay
          }
        }).then(function(response){
          var res = response.data.data;
          that.parkTotal = res.total
          that.park(res);
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      park:function(msg){
        var myChart = this.$echarts.init(document.getElementById('park'));
        var option;
        option = {
          color:['#67AEFF'],
          grid: {
            left:20,
            right:30,
            top:10,
            bottom:0,
            containLabel: true
          },
            xAxis: {
              type: 'category',
              data: msg.day,
              axisLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            splitLine:{
              lineStyle:{
                color:'rgba(255,255,255,0)'
              }
            },
            axisLabel:{
              color:"rgba(153,153,153,1)"
            },
            boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'value',
              axisLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            splitLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            axisLabel:{
              color:"rgba(153,153,153,1)"
            },
            },
            series: [{
              data: msg.nums,
              type: 'line',
              smooth: true,
              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0,
                      color: "#67AEFF" // 0% 处的颜色
                    }, {
                      offset:1,
                      color: "rgba(103,174,255,0)" // 100% 处的颜色
                    }],
                      globalCoord: false // 缺省为 false
                  }
                }
              },
              itemStyle : { normal: {label : {show: true}}},
            }]
        };

        option && myChart.setOption(option);
      },
      moneyClick:function(d){
        this.moneyMsg = (d == 1 ? '本月' : '上月');
        this.status = d;
        this.getMoney();
      },

      getMoney:function(e){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/money',
          params:{
            id:id,
            status:that.status
          }
        }).then(function(response){
          var res = response.data.data;
          that.moneyTotal = res.total;
          that.money(res);
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },


      money:function(msg){
        var myChart = this.$echarts.init(document.getElementById('money'));
        var option;
        option = {
          color:['#FFB300','#C549FF','#3D75FE'],
            tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}  ({d}%)"
          },
          legend: {
            top: '55',
            orient: 'vertical',
            x: '65%',
            y: 'center',
            itemWidth: 12,   // 设置图例图形的宽
            itemHeight: 12,  // 设置图例图形的高
            textStyle: {
              color: '#333333',  // 图例文字颜色
              padding:[5,0]
            },
          },
          series: [{
            name: '',
            type: 'pie',
            radius: ['35%', '85%'],
            center: ['33%', '50%'],
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center'
            },
            data: msg.data,
          },
          {
            name: '外边框',
            type: 'pie',
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['33%', '50%'],
            radius: ['95%', '95%'],
            label: {
                normal: {
                  show: false
                }
            },
            data: [{
                value: 3,
                name: '',
                itemStyle: {
                    normal: {
                        borderWidth: 1,
                        borderType: 'dotted',//dotted 虚线
                        borderColor: '#93E0D9'
                    }
                }
            }]
          }]
        };
        option && myChart.setOption(option);
      },

      ticketClick:function(d){
        this.ticketDay = d;
        this.getTicket();
      },

      getTicket:function(e){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/ticket',
          params:{
            id:id,
            days:that.ticketDay
          }
        }).then(function(response){
          var res = response.data.data;
          that.ticketTotal = res.total
          that.payments(res);
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      payments:function(msg){
        var myChart = this.$echarts.init(document.getElementById('payment'));
        var option;
        option = {
          color:['#FFAA3B'],
          grid: {
            left:20,
            right:30,
            top:10,
            bottom:0,
            containLabel: true
          },
            xAxis: {
              type: 'category',
              data: msg.day,
              axisLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            splitLine:{
              lineStyle:{
                color:'rgba(255,255,255,0)'
              }
            },
            axisLabel:{
              color:"rgba(153,153,153,1)"
            },
            boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'value',
              axisLine:{
                lineStyle:{
                  color:'rgba(153,153,153,.1)'
                }
              },
              splitLine:{
                lineStyle:{
                  color:'rgba(153,153,153,.1)'
                }
              },
              axisLabel:{
                color:"rgba(153,153,153,1)"
              },
            },
            series: [{
              barWidth: 10,
              data: msg.nums,
              type: 'bar',
              itemStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  1, 0, 0, 1,
                  [
                    {offset: 0, color: 'rgb(255,170,5)'},
                    {offset: 1, color: 'rgb(255,237,82)'}
                  ]
                ),
                barBorderRadius:[16, 16, 0, 0]
              }
            },
            label: {
              show: true,
              position: 'inside',
              valueAnimation: true,
              color:'#666666'
            },
          }]
        };
        option && myChart.setOption(option);
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .ScenicAdminApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .ScenicAdminApp .scenicList{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px
  }
  .ScenicAdminApp .scenicList img.fmt{
    float:left;
    width:35%;
    margin:10px;
    border-radius:4px
  }
  .ScenicAdminApp .scenicList .con{
    float:left;
    width:55%;
    margin-top:10px;
  }
  .ScenicAdminApp .scenicList .con h2{
    font-size:15px;
    color:#333;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .ScenicAdminApp .scenicList .con p{
    font-size:14px;
    color:#666;
    margin-top:13px;
  }
  .ScenicAdminApp .scenicList .level{
    clear:both;
    width:92%;
    margin:0 auto;
    font-size:15px;
    border-top:1px #fafafa solid;
    padding:10px 0 15px 0;
    color:#666
  }
  .ScenicAdminApp .scenicList .level font{
    color:#f00;
    font-weight:bold;
  }
  .ScenicAdminApp .scenicList .level span{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:2px
  }
  .ScenicAdminApp .scenicList .level span img{
    float:right;
    width:6px;
    margin:2px 0 0 8px
  }

  .ScenicAdminApp .parkData{
    width:92%;
    margin:15px auto 0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px;
    padding-bottom:20px
  }

  .ScenicAdminApp .parkData h2{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0 0 0;
    border-bottom:solid 1px #fafafa
  }
  .ScenicAdminApp .parkData h2 i{
    float:right;
    font-size:14px;
    font-style: normal;
    font-weight:normal;
    color:#999
  }
  .ScenicAdminApp .parkData h2 i img{
    width:6px;
    margin-left:5px
  }
  .ScenicAdminApp .parkData h2 .amounts{
    padding:15px 0 7px 0;
  }
  .ScenicAdminApp .parkData h2 .amounts span{
    font-size:22px
  }
  .ScenicAdminApp .parkData h2 .amounts font{
    font-size:12px;
    color:#999;
    font-weight:normal;
    position: relative;
    top:-2px;
  }
  .ScenicAdminApp .parkData h2 .amounts .tab{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:8px
  }
  .ScenicAdminApp .parkData h2 .amounts .tab a{
    font-size:12px;
    color:#666;
    margin-left:20px;
    font-weight:normal;
    position: relative;
  }
  .ScenicAdminApp .parkData h2 .amounts .tab a.curt:after{
    position: absolute;
    content: '';
    background: #333;
    width:15px;
    height: 2px;
    border-radius: 2px;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
  }
</style>